module.exports = __webpack_public_path__ + "img/send.fcdf2c3b.svg";